module.exports = __webpack_public_path__ + "static/media/why_start.e7471ef3.jpg";